// src/Utils/Items.js - Real projects (built with team)
import EshopImg from "../assets/images/eshop.png";
import NullifyImg from "../assets/images/nullify-site.png";
import BanoLifeImg from "../assets/images/banolife.jpg";
import NilentImg from "../assets/images/nilent.png";
import BrainhubImg from "../assets/images/brainhub.png";
import BanoLiveImg from "../assets/images/banolive.png";

const Items = [
  {
    id: 1,
    title: "ESHOP",
    description: "Modern e-commerce storefront for electronics—product catalog, cart, search and a sleek dark theme, built with the team.",
    technologies: ["React", "Redux", "Tailwind CSS", "REST API"],
    mainImage: EshopImg,
    liveLink: "https://eshop-tcj.netlify.app/",
    githubLink: "#",
    category: "E-Commerce",
    features: ["Product Catalog", "Cart & Checkout", "Search & Filter", "Dark / Light Mode"]
  },
  {
    id: 2,
    title: "Nullify AI",
    description: "AI workforce for product security—reasons and acts like a security engineer to find, triage and resolve vulnerabilities.",
    technologies: ["React", "Next.js", "Node.js", "AI/ML", "APIs"],
    mainImage: NullifyImg,
    liveLink: "https://www.nullify.ai/",
    githubLink: "#",
    category: "AI / SaaS",
    features: ["Vulnerability Detection", "Auto-Triage", "Security Analytics", "Continuous Learning"]
  },
  {
    id: 3,
    title: "Bano Life",
    description: "Healthcare & mobility platform showcasing electric wheelchairs and lifestyle products with articles and activities.",
    technologies: ["React", "Node.js", "CMS", "Responsive UI"],
    mainImage: BanoLifeImg,
    liveLink: "https://banolife.dk/",
    githubLink: "#",
    category: "Healthcare / E-Commerce",
    features: ["Product Showcase", "Articles & Activities", "Multilingual", "Contact & Support"]
  },
  {
    id: 4,
    title: "NILENT",
    description: "Sports education platform elevating athletes with courses, events and resources to grow both on and off the field.",
    technologies: ["React", "AWS Amplify", "Node.js", "Tailwind CSS"],
    mainImage: NilentImg,
    liveLink: "https://main.d2i7jgwyzqg9yr.amplifyapp.com/",
    githubLink: "#",
    category: "Education / Sports",
    features: ["Online Courses", "Events", "Athlete Resources", "Member Login"]
  },
  {
    id: 5,
    title: "Brainhub",
    description: "Software development company website presenting high-performing engineering teams, services and case studies.",
    technologies: ["React", "Next.js", "Tailwind CSS", "CMS"],
    mainImage: BrainhubImg,
    liveLink: "https://brainhub.eu/",
    githubLink: "#",
    category: "Corporate / Web",
    features: ["Services Showcase", "Case Studies", "Multilingual", "Lead Generation"]
  },
  {
    id: 6,
    title: "Bano Live",
    description: "Live streaming & social entertainment app—go live, meet new friends worldwide, play games and send virtual gifts.",
    technologies: ["React Native", "Node.js", "WebRTC", "Socket.io", "MongoDB"],
    mainImage: BanoLiveImg,
    liveLink: "https://play.google.com/store/apps/details?id=com.bano.live&hl=en",
    githubLink: "#",
    category: "Mobile App / Entertainment",
    features: ["Live Streaming", "Real-Time Chat", "In-App Games", "Virtual Gifts"]
  },
];

export default Items;
